import { Fragment, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import LotusLogo from "./LotusLogo";

const links = [
  { to: "/couples-therapy", label: "Couples Therapy" },
  { to: "/infidelity-trust", label: "Infidelity & Trust" },
  { to: "/post-relationship-counseling", label: "Post-Relationship" },
  { to: "/individual-therapy", label: "Individual Therapy" },
  { to: "/about-me", label: "About Me" },
  { to: "/my-approach", label: "My Approach" },
  { to: "/telehealth-faq", label: "Telehealth & FAQ" },
  { to: "/blog", label: "Blog" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/es", label: "Español" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-forest-900/95 border-b border-gold-500/25">
      <div className="max-w-[1800px] mx-auto px-5 sm:px-8 h-[100px] lg:h-[76px] grid grid-cols-[1fr_auto] lg:grid-cols-[1fr_auto_1fr] items-center gap-6">
        <Link to="/" className="flex items-center gap-3.5 shrink-0 justify-self-start" data-testid="nav-logo-link" onClick={() => setOpen(false)}>
          <LotusLogo size={64} testId="nav-logo-badge" className="w-16 h-16 lg:w-12 lg:h-12 shadow-[0_6px_20px_rgba(0,0,0,0.35)]" />
          <span className="leading-tight">
            <span className="block font-serif text-[26px] lg:text-[30px] font-medium text-[#F2CE6B] tracking-wide whitespace-nowrap [-webkit-text-stroke:1.25px_#0D0D0D] [paint-order:stroke_fill]" data-testid="nav-brand-name">
              Holistic Healing
            </span>
            <span className="block text-[11px] lg:text-xs font-medium uppercase tracking-[0.28em] text-cream-50 whitespace-nowrap" data-testid="nav-brand-subtitle">
              Psychotherapy, Inc.
            </span>
          </span>
        </Link>

        <nav className="hidden min-[1750px]:flex items-center justify-center gap-2" data-testid="nav-desktop">
          {links.map((l, i) => (
            <Fragment key={l.to}>
              {i > 0 && <span className="w-1 h-1 rotate-45 bg-gold-500/60 shrink-0" aria-hidden="true" />}
              <NavLink
                to={l.to}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={({ isActive }) =>
                  `text-[13px] font-medium tracking-wide whitespace-nowrap transition-colors duration-300 hover:text-gold-400 ${
                    isActive ? "text-gold-400" : "text-cream-50/85"
                  }`
                }
              >
                {l.label}
              </NavLink>
            </Fragment>
          ))}
        </nav>

        <div className="flex items-center gap-3 justify-self-end">
          <a
            href="tel:+16573339466"
            data-testid="nav-phone-link"
            className="hidden min-[1950px]:flex items-center gap-2 text-[13px] font-medium text-cream-50/85 whitespace-nowrap hover:text-gold-400 transition-colors duration-300"
          >
            <Phone size={14} strokeWidth={2.2} /> (657) 333-9466
          </a>
          <Link
            to="/contact"
            data-testid="nav-schedule-cta"
            className="hidden sm:inline-flex items-center rounded-full bg-cream-50 text-forest-900 text-[13px] font-semibold tracking-wide px-5 py-2.5 transition-colors duration-300 hover:bg-white hover:shadow-[0_8px_24px_rgba(0,0,0,0.25)]"
          >
            Schedule a Consultation
          </Link>
          <button
            className="min-[1750px]:hidden text-cream-50 p-2"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="min-[1750px]:hidden border-t border-gold-500/25 bg-forest-900 px-5 py-6 space-y-4" data-testid="nav-mobile">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block font-serif text-2xl ${isActive ? "text-gold-400" : "text-cream-50"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            data-testid="nav-mobile-schedule-cta"
            className="inline-flex items-center rounded-full bg-cream-50 text-forest-900 text-sm font-semibold px-6 py-3 mt-2"
          >
            Schedule a Consultation
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
